//Global promise to call onYouTubeAPIReady after scripts are loaded
//only execute onYoutubeIframeAPIReady once
//https://developers.google.com/youtube/iframe_api_reference
const YTReady = new Promise( (resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve(window.YT);
});

export default YTReady